export { default as Avatar } from './Avatar';

export type { AvatarProps } from './Avatar';
